import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import { connect } from "react-redux"

import { withTranslation } from "react-i18next"
import {
  addPackageInstaller,
  getGppByGpId,
  getListEngineer,
  projectProcess,
  resetGasProcessFlag,
} from "store/actions"
import "./gasProjectExecutor.scss"

import { Layout, Row, notification } from "antd"
const { Content } = Layout
import ListGasProject from "./ListGasProject"
notification.config({
  duration: 1,
  rtl: true,
})
const Index = props => {
  const { triggerReload, onResetGasProcessFlag, matches_sm } = props
  const [api, contextHolder] = notification.useNotification()
  const [errorMessage, setErrorMessage] = useState(null)
  const openNotification = (type, placement, message) => {
    api[type]({
      message,
      placement,
    })
  }
  useEffect(() => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
    if (errorMessage) openNotification("warning", "top", props.error)
    onResetGasProcessFlag()
  }, [errorMessage, props.success, props.error])

  const contentStyle = {
    backgroundColor: "#fff",
    margin: 2,
    paddingInline: 2,
    borderRadius: 2,
  }

  const [expanded, setExpanded] = useState("")
  const handleChangeExpand = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  return (
    <div className="page-content">
      <MetaTags>
        <title>پرونده | واحد گاز</title>
      </MetaTags>

      {contextHolder}
      <ListGasProject
        matches_sm={matches_sm}
        expanded={expanded} 
        handleChangeExpand={handleChangeExpand}
        openNotification={openNotification}
        reload={triggerReload}
      />
    </div>
  )
}


const mapStateToProps = ({ USERs, GasProjectProcesses, Engineers, GasProjects, }) => ({
  lstEngineer: Engineers.lstEngineer,
  loading: GasProjectProcesses.loading,
  lstGpp: GasProjectProcesses.lstGpp,
  error: GasProjectProcesses.error,
  success: GasProjectProcesses.success,
  userBalance: USERs.userBalance,
  selectedProject: GasProjectProcesses.selectedProject,
  countSelectedProject: GasProjectProcesses.countSelectedProject,
  flatSelectedProject: GasProjectProcesses.flatSelectedProject,
  triggerReload: GasProjectProcesses.triggerReload,
  lstPackageInstaller: GasProjects.lstPackageInstaller,
  gasProjectSuccess: GasProjects.success,
  gasProjectError: GasProjects.error,

})

const mapDispatchToProps = dispatch => ({
  onGetGppByGpId: gasProjectId => dispatch(getGppByGpId(gasProjectId)),
  onGetListEngineer: () => dispatch(getListEngineer()),
  onProjectProcess: data => dispatch(projectProcess(data)),
  onResetGasProcessFlag: () => dispatch(resetGasProcessFlag()),
  onAddPackageInstaller: gasProject => dispatch(addPackageInstaller(gasProject))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Index))
